import React from "react";

export const SkeletonPost = () => (
  <div className="rounded-2xl border border-white/10 bg-zinc-900/60 p-6 space-y-5">
    <div className="flex items-center gap-3">
      <div className="h-9 w-9 rounded-xl shimmer" />
      <div className="flex-1 space-y-2">
        <div className="h-3 w-20 shimmer rounded" />
        <div className="h-5 w-28 shimmer rounded" />
      </div>
    </div>
    <div className="space-y-2">
      <div className="h-3 w-14 shimmer rounded" />
      <div className="h-6 w-full shimmer rounded" />
    </div>
    <div className="space-y-2">
      <div className="h-3 w-20 shimmer rounded" />
      <div className="h-4 w-full shimmer rounded" />
      <div className="h-4 w-5/6 shimmer rounded" />
      <div className="h-4 w-4/6 shimmer rounded" />
    </div>
    <div className="space-y-2">
      <div className="h-3 w-16 shimmer rounded" />
      <div className="h-10 w-2/3 shimmer rounded-lg" />
    </div>
  </div>
);

export default SkeletonPost;
